import { ISocialButton, ISocialIconStyle } from '@wix/shoutout-email-model-v3';
import {
  Facebook,
  Instagram,
  LinkedIn,
  Pinterest,
  SoundCloud,
  Twitter,
  Youtube,
} from './icons';

export const enum SocialButtonTypes {
  facebook = 'facebook',
  instagram = 'instagram',
  linkedIn = 'linkedIn',
  pinterest = 'pinterest',
  soundCloud = 'soundCloud',
  twitter = 'twitter',
  youtube = 'youtube',
}

export interface ISocialIcon extends ISocialButton {
  styles: ISocialIconStyle;
  iconColor: string;
}

export const SocialMediaIcons = {
  facebook: Facebook,
  instagram: Instagram,
  linkedIn: LinkedIn,
  pinterest: Pinterest,
  soundCloud: SoundCloud,
  twitter: Twitter,
  youtube: Youtube,
};

export const ICON_SIZES = {
  small: 'iconSizeSmall',
  medium: 'iconSizeMedium',
  large: 'iconSizeLarge',
};
